<div
    class="relative z-10"
    aria-labelledby="slide-over-title"
    role="dialog"
    aria-modal="true"
>
    <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity ease-in-out duration-500"
        [ngClass]="visible ? 'visible opacity-100' : 'invisible opacity-0'"
    ></div>

    <div
        class="fixed inset-0 overflow-hidden overlay-container"
        [ngClass]="visible ? 'visible' : 'invisible'"
    >
        <div class="absolute inset-0 overflow-hidden" #overlay>
            <div
                class="pointer-events-none fixed inset-y-0 left-0 flex max-w-full"
            >
                <div
                    class="pointer-events-auto w-screen transform transition ease-in-out duration-300"
                    [ngClass]="{
                        '-translate-x-full': !visible,
                        'translate-x-0': visible
                    }"
                >
                    <div class="flex h-full flex-col bg-white shadow-xl">
                        <div
                            class="flex-1 height-full flex flex-col overflow-y-hidden py-6 px-4 sm:px-6"
                        >
                            <div
                                class="flex justify-between items-center mb-6 border-b border-[#E5E8EC] pb-4"
                            >
                                <div class="flex gap-2">
                                    <button
                                        (click)="closeCategories()"
                                        class="flex items-center"
                                    >
                                        <img
                                            alt="Venduro"
                                            class="mr-5"
                                            src="../assets/icons/left-arrow.svg"
                                        />
                                    </button>
                                    <span
                                        class="text-[20px] text-[#444343] font-semibold"
                                        >Categories</span
                                    >
                                </div>
                                <button (click)="onClose()">
                                    <img
                                        alt="Close Menu"
                                        src="assets/icons/close-icon.svg"
                                    />
                                </button>
                            </div>
                            <ul
                                class=""
                                *ngIf="collectionTree$ | async as tree"
                            >
                                <li *ngFor="let collection of tree.children">
                                    <button
                                        class="flex justify-between w-full p-4 justify-center align-center items-center font-medium text-[#444343] text-[14px]"
                                        (click)="onL0Click($event, collection)"
                                    >
                                        <h1>{{ collection.name }}</h1>
                                        <div>
                                            <img
                                                alt="Go To Collection"
                                                src="../../../../assets/icons/right-chevron.svg"
                                            />
                                        </div>
                                    </button>
                                    <ul
                                        *ngIf="collection.children.length"
                                        [ngClass]="
                                            selected0 === collection.id
                                                ? 'block'
                                                : 'hidden'
                                        "
                                    >
                                        <li
                                            class="level1"
                                            *ngFor="
                                                let level1 of collection.children
                                            "
                                        >
                                            <button
                                                type="button"
                                                class="collections-menu-mobile__level1-button group"
                                                (click)="onL1Click($event, level1)"
                                            >
                                                {{ level1.name }}
                                            </button>
                                            <ul
                                                *ngIf="level1.children.length"
                                                class="expandable"
                                                [class.expanded]="
                                                    selected1 === level1.id
                                                "
                                            >
                                                <li
                                                    class="level2"
                                                    *ngFor="
                                                        let level2 of level1.children
                                                    "
                                                >
                                                    <a
                                                        class=""
                                                        (click)="onClose()"
                                                        [routerLink]="[
                                                            '/category',
                                                            level2.slug
                                                        ]"
                                                        >{{ level2.name }}</a
                                                    >
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a
                                        class="flex justify-between w-full p-4 justify-center align-center items-center font-medium text-[#444343] text-[14px]"
                                        routerLink="/pricelists/pre-order"
                                        (click)="onClose()"
                                    >
                                        <h1>Pre-Orders</h1>
                                        <div>
                                            <img
                                                alt="Go To Pre-Orders"
                                                src="../../../../assets/icons/right-chevron.svg"
                                            />
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="flex justify-between w-full p-4 justify-center align-center items-center font-medium text-[#444343] text-[14px]"
                                        routerLink="/pricelists/short-offer"
                                        (click)="onClose()"
                                    >
                                        <h1>Special Offers</h1>
                                        <div>
                                            <img
                                                alt="Go To Special Offers"
                                                src="../../../../assets/icons/right-chevron.svg"
                                            />
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        class="flex justify-between w-full p-4 justify-center align-center items-center font-medium text-[#444343] text-[14px]"
                                        routerLink="/consolidated-feed"
                                        (click)="onClose()"
                                    >
                                        <h1>Consolidated Feed</h1>
                                        <div>
                                            <img
                                                alt="Go To Consolidated Feed"
                                                src="../../../../assets/icons/right-chevron.svg"
                                            />
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
